import { useI18n }    from '../../../../shared/i18n/useI18n.js'

import { 
  formatMainBarLabel, 
  formatSingleVal,   
  isSelfLabeled }         from '../../utils/filterFormatters.js'
import { isFilterActive } from '../../utils/filterUtils.js'
import { 
  FILTER_IDS, 
  COMPONENT_TYPES }       from '../../constants/filterConstants.js'
    
import { FilterCard }     from './FilterCard.jsx'
import { FilterInput }    from './FilterInput.jsx'

import styles from './CatalogAdditionalPanel.module.scss'

// ── CatalogAdditionalPanel ────────────────────────────────────────────────────

/**
 * Expandable filter panel rendered below CatalogMainBar.
 *
 * Displays all supported entries that Are NOT in mainFilters (those live in the main bar)
 *
 * Layout: 3-column CSS grid (desktop), 2-col (tablet), 1-col (mobile).
 *
 * @param {object}   props
 * @param {object}   props.catalogFilters
 * @param {object}   [props.defaultFiltersConfig={}]  - CMS default filter state (overlay applied)
 * @param {object}   props.filtersConfig             - current active filter values
 * @param {object}   props.fullFiltersRange           - full data range per filter id
 * @param {(id: string, value: *) => void} props.onFilterChange
 */
export function CatalogAdditionalPanel({ 
    catalogFilters,
    defaultFiltersConfig = {},
    filtersConfig,
    fullFiltersRange,
    onFilterChange,
  }) {
  // ── i18n ──────────────────────────────────────────────────────────────────
  const { t } = useI18n()

  const { additionalFilters} = catalogFilters

  return (
    <div
      id="catalog-additional-panel"
      className={styles.panel}
      role="region"
      aria-label={t('catalog.extra_filters_region')}
    >
      {additionalFilters.map(entry => {
        if (!entry) return null
        const { id, labelKey } = entry
        const value   = filtersConfig?.[id]
        const range   = fullFiltersRange?.[id]
        const label  = t(labelKey)
        const active  = isFilterActive(id, filtersConfig, defaultFiltersConfig)

        // valueSummary only for RangeSlider (MultiSelect chips carry the value)
        const valueSummary = entry.component === COMPONENT_TYPES.RANGE_SLIDER && Array.isArray(value)
          ? (value[0] === value[1]
              ? formatSingleVal(id, value[0])
              : formatMainBarLabel(id, value))
          : undefined

        return (
          <FilterCard
            key={id}
            label={label}
            valueSummary={valueSummary}
            isActive={active}
            hideLabel={isSelfLabeled(entry)}
          >
            <FilterInput
              entry={entry}
              value={value}
              range={range}
              isActive={active}
              onChange={v => onFilterChange(id, v)}
            />
          </FilterCard>
        )
      })}
    </div>
  )
}
